import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import { Provider } from "react-redux";
import Notification from "./utils/Notification/Notification";
import { store } from "./store/";
import httpClient from "./utils/httpClient";
import { ScFontMontserrat } from "@bigdata/ui-kit";

httpClient.initialize();

ReactDOM.render(
  <Provider store={store}>
    <ScFontMontserrat>
      <App />
      <Notification />
    </ScFontMontserrat>
  </Provider>,
  document.getElementById("root")
);
